export default {
  events: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  prospects: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
